import React, { useEffect, useState } from "react";
import { SEND_TEST_SMS } from "utils/mutations";
import { useMutation } from "@apollo/react-hooks";
import { varParser } from "utils";
import { useSelector } from "react-redux";
import PhoneInput from "react-phone-input-2";
import "../../styles/marketing-dashboard.css";
import "react-phone-input-2/lib/style.css";

const SMSPhoneInput = ({ testNumber, setTestNumber }) => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);
  const message = useSelector((state) => state.smsBatching.message);
  const emailList = useSelector((state) => state.smsBatching.emailList);
  const [sendTestSms] = useMutation(SEND_TEST_SMS);
  const timer = setTimeout(() => {
    setSuccess(null);
    setError(null);
  }, 3500);
  const handleTestSms = async () => {
    setLoading(true);
    if (!message || !testNumber) {
      setLoading(false);
      setSuccess(false);
      setError("invalid number");
    } else {
      const payload = {
        body: varParser(message, emailList),
        phone_number: testNumber,
      };
      await sendTestSms({ variables: payload }).then((response) => {
        console.log(response.data.sendTestSMS.status);
        if (response.data.sendTestSMS.status === `OK`) {
          setSuccess(true);
          setLoading(false);
        }
        setError(true);
        setLoading(false);
      });
    }
    return () => clearTimeout(timer);
  };
  useEffect(() => {
    return () => {
      setSuccess(null);
      setError(null);
      setLoading(false);
      clearTimeout(timer);
    };
  }, []);
  return (
    <div className="flex-col mx-auto text-black justify-center text-center">
      <PhoneInput
        disableDropdown={Boolean(true)}
        country="us"
        value={testNumber}
        defaultValue={testNumber || null}
        aria-label="test phone number input"
        countryCodeEditable={Boolean(false)}
        onChange={setTestNumber}
      />
      {success ? (
        <button
          type="button"
          className=" bg-green-500 my-3 py-1 px-3 mx-auto"
        >
          <i className="fas fa-check-circle " />
        </button>
      ) : (
        <>
          {error ? (
            <button
              type="button"
              className=" bg-red-500 my-3 py-1 px-3 mx-auto"
            >
              <small>
                  Error sending SMS
                <i className="mx-1 fas fa-exclamation-circle" />
              </small>
            </button>
          ) : (
            <button
              aria-label="send test SMS"
              type="button"
              className=" bg-yellow-600 my-3 py-1 px-3 mx-auto animate__animated animate__bounce"
              onClick={handleTestSms}
            >
              {loading ? (
                <i className="fas fa-spinner text-white fa-spin p-1" />
              ) : (
                <small className="text-white">
                    Send Test SMS
                  <i className="fas fa-paper-plane text-white p-1" />
                </small>
              )}
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default SMSPhoneInput;
